import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppProfileService } from '../../services/profile.service';
import { TfaSetupDto } from '../../common/TfaSetupDto';
import { Observable, switchMap, take, tap } from 'rxjs';
import { Location } from '@angular/common';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective } from '../../directives/async-click.directive';

@Component({
    imports: [ReactiveFormsModule, AsyncClickDirective],
    selector: 'app-tfa-configuration',
    templateUrl: './tfa-configuration.component.html',
    styleUrls: ['./tfa-configuration.component.css']
})
export class TfaSetupComponent implements OnInit {
  profileService = inject(AppProfileService);
  private location = inject(Location);
  private callApiService = inject(CallApiService);

  public tfaForm = this.createForm();
  public isLoading: boolean = true;
  public tfaEnabled: boolean = false;
  public qrInfo: string = '';
  public authenticatorKey: string = '';

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.tfaForm = this.createForm();

    this.profileService.getTfaSetup().subscribe((response: TfaSetupDto) => {
      this.tfaEnabled = response.isTfaEnabled ?? false;
      this.qrInfo = response.formattedKey ?? '';
      this.authenticatorKey = response.authenticatorKey ?? '';
      this.isLoading = false;
    });
  }

  createForm() {
    return new FormGroup({
      code: new FormControl('', [Validators.required]),
    });
  }

  validateControl = (controlName: string) => {
    return this.tfaForm.get(controlName)?.invalid && this.tfaForm.get(controlName)?.touched;
  };

  hasError = (controlName: string, errorName: string) => {
    return this.tfaForm.get(controlName)?.hasError(errorName);
  };

  // Arrow property → already bound; bind directly as [asyncClick]="disableTfa".
  disableTfa = (): Observable<unknown> =>
    this.callApiService
      .callWithToasts$(
        this.profileService.disableTfa(),
        null,
        $localize`Zwei-Faktor-Authentifizierung konnte nicht deaktiviert werden`
      )
      .pipe(tap(() => this.refresh()));

  // Needs the form value → returns a factory: [asyncClick]="enableTfa(tfaForm.value)".
  enableTfa = (tfaFormValue: any) => (): Observable<unknown> => {
    const tfaForm = { ...tfaFormValue };

    return this.callApiService
      .callWithToasts$(
        this.profileService.currentProfile$.pipe(
          take(1),
          switchMap((p) => {
            const tfaSetupDto: TfaSetupDto = {
              email: p.user.email,
              code: tfaForm.code,
              authenticatorKey: this.authenticatorKey,
            };
            return this.profileService.postTfaSetup(tfaSetupDto);
          })
        ),
        null,
        $localize`Zwei-Faktor-Authentifizierung konnte nicht aktiviert werden`
      )
      .pipe(tap(() => this.refresh()));
  };

  onBackClicked() {
    this.location.back();
  }
}
